import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import removeUndefined from '../utilities/Data/removeUndefined'
import undefinedToDeletes from '../utilities/Data/undefinedToDeletes'
import maybe from '../utilities/maybe'

const setPost = async ({ postDraft }) => {
	try {
		const post = removeUndefined(undefinedToDeletes(postDraft))
		let postId = post.postId
		const isCreate = !postId
		const postColl = firestore.collection('posts')
		const postDocRef = isCreate ? postColl.doc() : postColl.doc(postId)
		postId = postDocRef.id

		await postDocRef.set({
			...post,
			postId,
			...maybe({ createdTimestamp: firebase.firestore.FieldValue.serverTimestamp() }, isCreate),
			modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp()
		}, { merge: true })

		return { postId }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, { postDraft }, exception)
	}
}

export default setPost



// WEBPACK FOOTER //
// ./src/dataservices/setPost.js